import debounce from "debounce";
import { compatibleMemberDecorator } from "vue-facing-decorator/dist/esm/deco3/utils";
import { obtainSlot } from "vue-facing-decorator/dist/esm/utils";
export function decorator(key, option) {
    return compatibleMemberDecorator(function (proto, name) {
        const slot = obtainSlot(proto);
        const map = slot.obtainMap("watch");
        let handler = proto[name];
        if (option?.debounce != null && option.debounce > 0) {
            handler = debounce(handler, option.debounce, { immediate: option.debounceImmediate ?? false });
        }
        const opt = Object.assign({}, option ?? {}, {
            key: key,
            handler: handler
        });
        if (map.has(name)) {
            const t = map.get(name);
            if (Array.isArray(t)) {
                t.push(opt);
            }
            else {
                map.set(name, [t, opt]);
            }
        }
        else {
            map.set(name, opt);
        }
    });
}
;
//# sourceMappingURL=watch.js.map